<template>
    <v-container>
       <v-row v-if="loading" justify="center" class="mt-10">
         <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
       </v-row>
  
       <v-row v-else-if="error">
         <v-col>
           <v-alert type="error" prominent>{{ error }}</v-alert>
         </v-col>
       </v-row>
  
      <v-row v-else-if="announcement">
        <v-col cols="12" md="8">
           <v-carousel v-if="announcement.images && announcement.images.length > 0" show-arrows="hover" cycle hide-delimiters class="mb-4 elevation-2">
             <v-carousel-item
               v-for="image in announcement.images"
               :key="image.id"
               :src="getImageUrl(image.url)"
               cover
             ></v-carousel-item>
           </v-carousel>
            <v-img v-else height="300" src="https://via.placeholder.com/800x400?text=ResimYok" cover class="mb-4 grey lighten-2"></v-img>
  
  
          <v-card>
            <v-card-title class="text-h4 d-flex align-center">
                {{ announcement.title }}
                 <v-chip v-if="announcement.is_verified" color="success" size="small" prepend-icon="mdi-check-decagram" class="ml-4">Onaylı</v-chip>
                 <v-spacer></v-spacer>
                  <template v-if="canEditOrDelete">
                      <v-btn icon color="primary" size="small" class="mr-2" @click="editAnnouncement">
                         <v-icon>mdi-pencil</v-icon>
                          <v-tooltip activator="parent" location="top">Düzenle</v-tooltip>
                      </v-btn>
                       <v-btn icon color="error" size="small" @click="confirmDelete">
                           <v-icon>mdi-delete</v-icon>
                           <v-tooltip activator="parent" location="top">Sil</v-tooltip>
                       </v-btn>
                   </template>
                   <template v-if="isAdminOrMod && !canEditOrDelete"> <v-btn
                          icon
                          :color="announcement.is_verified ? 'warning' : 'success'"
                          size="small"
                          @click="toggleVerification"
                          :loading="verifying"
                      >
                         <v-icon>{{ announcement.is_verified ? 'mdi-close-octagon' : 'mdi-check-decagram' }}</v-icon>
                          <v-tooltip activator="parent" location="top">{{ announcement.is_verified ? 'Onayı Kaldır' : 'Onayla' }}</v-tooltip>
                      </v-btn>
                   </template>
            </v-card-title>
  
            <v-divider></v-divider>
  
            <v-card-text>
              <v-list density="compact">
                <v-list-item v-if="announcement.price" prepend-icon="mdi-cash">
                  <v-list-item-title><strong>Fiyat:</strong> {{ formattedPrice }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="announcement.location" prepend-icon="mdi-map-marker">
                   <v-list-item-title><strong>Konum:</strong> {{ announcement.location }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="announcement.contact_info" prepend-icon="mdi-phone">
                   <v-list-item-title><strong>İletişim:</strong> {{ announcement.contact_info }}</v-list-item-title>
                </v-list-item>
                 <v-list-item v-if="announcement.user" prepend-icon="mdi-account">
                   <v-list-item-title>
                      <strong>İlan Sahibi:</strong> {{ announcement.user.username }}
                       <span v-if="announcement.user.profile_title">({{ announcement.user.profile_title }})</span>
                       <v-chip v-if="announcement.user.is_verified" size="x-small" color="blue" class="ml-2">Doğrulanmış Kullanıcı</v-chip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item prepend-icon="mdi-calendar-clock">
                    <v-list-item-title><strong>Yayın Tarihi:</strong> {{ formattedDate(announcement.createdAt) }}</v-list-item-title>
                </v-list-item>
              </v-list>
  
              <h3 class="text-h6 mt-6 mb-2">Açıklama</h3>
              <p style="white-space: pre-wrap;">{{ announcement.description }}</p>
            </v-card-text>
  
          </v-card>
        </v-col>
  
        <v-col cols="12" md="4">
           <v-card outlined>
              <v-card-title>İlan Sahibi</v-card-title>
              <v-card-text v-if="announcement.user">
                 <v-list-item :prepend-icon="'mdi-account-circle'" :title="announcement.user.username"></v-list-item>
                  <v-list-item v-if="announcement.user.profile_title" :prepend-icon="'mdi-briefcase'" :title="announcement.user.profile_title"></v-list-item>
                   <v-btn
                      v-if="isAuthenticated && userId !== announcement.userId"
                      color="secondary"
                      block
                      class="mt-4"
                      @click="sendMessage"
                   >
                      <v-icon left>mdi-message-text</v-icon> Mesaj Gönder
                   </v-btn>
              </v-card-text>
                <v-card-text v-else>
                    Kullanıcı bilgisi yüklenemedi.
                </v-card-text>
           </v-card>
  
           <v-card outlined class="mt-4" v-if="isAuthenticated">
                <v-card-text class="d-flex justify-space-around">
                     <v-btn @click="toggleFavorite" :color="isFavorited ? 'pink' : 'grey'" icon>
                         <v-icon>{{ isFavorited ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                           <v-tooltip activator="parent" location="bottom">{{ isFavorited ? 'Favorilerden Çıkar' : 'Favorilere Ekle' }}</v-tooltip>
                     </v-btn>
                      <v-btn @click="toggleAlert" :color="hasAlert ? 'blue' : 'grey'" icon>
                          <v-icon>{{ hasAlert ? 'mdi-bell-ring' : 'mdi-bell-outline' }}</v-icon>
                            <v-tooltip activator="parent" location="bottom">{{ hasAlert ? 'Fiyat Alarmını Kaldır' : 'Fiyat Alarmı Kur' }}</v-tooltip>
                      </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
      </v-row>
  
       <v-dialog v-model="deleteDialog" persistent max-width="400">
           <v-card>
               <v-card-title class="headline">Duyuruyu Sil</v-card-title>
               <v-card-text>Bu duyuruyu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</v-card-text>
               <v-card-actions>
                   <v-spacer></v-spacer>
                   <v-btn color="grey darken-1" text @click="deleteDialog = false">İptal</v-btn>
                   <v-btn color="error" :loading="deleting" @click="deleteConfirmed">Sil</v-btn>
               </v-card-actions>
           </v-card>
       </v-dialog>
  
    </v-container>
  </template>
  
  <script>
  import announcementService from '@/services/announcementService';
  // import favoriteService from '@/services/favoriteService'; // Gerekli
  // import alertService from '@/services/alertService';     // Gerekli
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'AnnouncementDetail',
    props: {
      id: { // Router'dan gelen id parametresi
        type: [String, Number],
        required: true
      }
    },
    data() {
      return {
        announcement: null,
        loading: false,
        error: null,
        deleteDialog: false,
        deleting: false,
        verifying: false,
        isFavorited: false, // TODO: Backend'den çekilecek
        hasAlert: false,     // TODO: Backend'den çekilecek
      };
    },
    computed: {
       ...mapGetters('auth', ['isAuthenticated', 'currentUser', 'userId', 'userRole']),
       formattedPrice() {
          if (!this.announcement?.price) return 'Belirtilmemiş';
          return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(this.announcement.price);
      },
      isAdminOrMod() {
          return this.userRole === 'admin' || this.userRole === 'moderator';
      },
       canEditOrDelete() {
           if (!this.isAuthenticated) return false;
           return this.isAdminOrMod || (this.announcement && this.announcement.userId === this.userId);
       }
    },
    methods: {
      async fetchAnnouncement() {
        this.loading = true;
        this.error = null;
        try {
          const response = await announcementService.getAnnouncement(this.id);
          this.announcement = response.data;
           // TODO: Favori ve alarm durumunu backend'den kontrol et
           // this.checkFavoriteStatus();
           // this.checkAlertStatus();
        } catch (err) {
          this.error = err.response?.data?.message || 'Duyuru yüklenemedi.';
           if (err.response?.status === 404) {
               this.error = 'Duyuru bulunamadı.';
           }
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
       formattedDate(dateString) {
          if (!dateString) return '';
          const date = new Date(dateString);
          return date.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' });
      },
       getImageUrl(url) {
          // AnnouncementCard'daki gibi URL'yi düzelt
          const backendBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:5001';
          if (!url) return '';
           if (!url.startsWith('/') && !url.startsWith('http')) {
               const baseUrl = backendBaseUrl.replace('/api', '');
               return `${baseUrl}/${url}`;
           }
           if (url.startsWith('/')) {
                const baseUrl = backendBaseUrl.replace('/api', '');
               return `${baseUrl}${url}`;
           }
           return url;
       },
        editAnnouncement() {
           // TODO: Düzenleme sayfasına yönlendir
           this.$router.push({ name: 'AnnouncementEdit', params: { id: this.id } }); // Edit route gerekli
        },
        confirmDelete() {
            this.deleteDialog = true;
        },
         async deleteConfirmed() {
            this.deleting = true;
             try {
                 await announcementService.deleteAnnouncement(this.id);
                 this.deleteDialog = false;
                 this.$router.push({ name: 'AnnouncementsList' }); // Listeye geri dön
                 // TODO: Başarı mesajı göster (Snackbar vb.)
             } catch (error) {
                  console.error("Silme hatası:", error);
                  this.error = error.response?.data?.message || 'Duyuru silinemedi.';
                  // TODO: Hata mesajı göster
             } finally {
                  this.deleting = false;
             }
         },
         async toggleVerification() {
             this.verifying = true;
              const newStatus = !this.announcement.is_verified;
              try {
                  const response = await announcementService.verifyAnnouncement(this.id, newStatus);
                  this.announcement.is_verified = response.data.is_verified; // Güncel durumu al
                   // TODO: Başarı mesajı göster
              } catch (error) {
                   console.error("Onaylama hatası:", error);
                    // TODO: Hata mesajı göster
              } finally {
                   this.verifying = false;
              }
         },
          async toggleFavorite() {
               if (!this.isAuthenticated) return;
               try {
                  if (this.isFavorited) {
                      // await favoriteService.removeFavorite(this.id);
                       console.log("Remove favorite - Backend call needed");
                  } else {
                       // await favoriteService.addFavorite(this.id);
                        console.log("Add favorite - Backend call needed");
                  }
                   this.isFavorited = !this.isFavorited; // Durumu tersine çevir (backend'den sonra)
               } catch (error) {
                    console.error("Favori hatası:", error);
               }
          },
           async toggleAlert() {
               if (!this.isAuthenticated) return;
                try {
                  if (this.hasAlert) {
                       // await alertService.removeAlert(this.id); // veya alert id'si
                        console.log("Remove alert - Backend call needed");
                  } else {
                       // await alertService.addAlert(this.id, { type: 'price_change' });
                         console.log("Add alert - Backend call needed");
                  }
                   this.hasAlert = !this.hasAlert; // Durumu tersine çevir (backend'den sonra)
               } catch (error) {
                    console.error("Alarm hatası:", error);
               }
           },
            sendMessage() {
               // TODO: Mesajlaşma sayfasına veya component'ine yönlendir
               this.$router.push({ name: 'Messages', query: { recipient: this.announcement.userId } });
               console.log("Mesaj gönder tıklandı, kullanıcı:", this.announcement.userId);
            }
  
    },
    created() {
      this.fetchAnnouncement();
    },
    watch: {
        // Eğer aynı route üzerinde ID değişirse (pek olası değil ama) tekrar yükle
        id() {
            this.fetchAnnouncement();
        }
    }
  };
  </script>